import React,{useEffect,useState} from "react";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import UserService from "../../../services/UserService";


// const initialUser = {
//     firstName: user.firstName,
//     lastName: '',
//     email: '',
//     username: '',
//     agentId: 1,
//     clientId: 1,
//     roleId: 1,
//     userId: JSON.parse(localStorage.getItem('userId')),
// }

const EditUser = () => {

    const [user, setUser] = useState({})
    const handleChange = name => ({ target: { value } }) => {
        setUser({ ...user, [name]: value })
    }

    const handleUpdate = (e) => {
       e.preventDefault()

       //console
       //call update endpoint
    }


    useEffect(() => {
        const userId = JSON.parse(localStorage.getItem('userId'))
        console.log(user)
        UserService.getUser(userId)
        .then(res => {
            console.log(res)
            setUser(res.data)
        }).catch(err => {
            console.log(err)
        })
    },[])

    return(
        <div>
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/view-users">
                                <a href>Users</a>/
                            </Link>
                        </ul>
                        <div className="row mt">
                            <div className="card col-lg-12">
                                <div className="content-panel bg-white p-2">
                                    <div className="form container col-md-6 bg-white mt-5 p-5">
                                        <form>
                                            <TextField
                                                autoFocus
                                                margin="dense"
                                                label="Name"
                                                type="text"
                                                fullWidth
                                                value={user.firstname}
                                                onChange={handleChange('fullName')}
                                            />

                                            <TextField
                                                margin="dense"
                                                label="Last Name"
                                                type="text"
                                                fullWidth
                                                value={user.lastname}
                                                onChange={handleChange('lastname')}
                                            />
                                            <TextField
                                                margin="dense"
                                                label="User Email"
                                                type="text"
                                                fullWidth
                                                value={user.email}
                                                onChange={handleChange('email')}
                                            />
                                            <Button onClick={handleUpdate} className="btn btn-block mt-4 mb-3 btn-secondary text-primary">
                                                Update
                                            </Button>
                                        </form>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditUser;
